var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHealth = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 108.826 108.826",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  d: "M71.488 108.824h-34.15a3.19 3.19 0 0 1-3.188-3.188V74.674H3.19A3.19 3.19 0 0 1 0 71.486v-34.15a3.19 3.19 0 0 1 3.188-3.188H34.15V3.186A3.19 3.19 0 0 1 37.34-.002h34.15a3.19 3.19 0 0 1 3.188 3.188v30.962h30.961a3.19 3.19 0 0 1 3.188 3.188v34.15a3.19 3.19 0 0 1-3.188 3.188H74.677v30.962a3.19 3.19 0 0 1-3.189 3.188",
  className: "health_svg__svg-safari-fix"
})));
export default SvgHealth;